import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenGroupsAllComponent} from './components/loren-groups-all/loren-groups-all.component';
import {LorenAllGroupsResolver} from './resolvers/loren-all-groups.resolver';

const routes: Routes = [
    {
        path: '',
        resolve: {
            groups: LorenAllGroupsResolver
        },
        component: LorenGroupsAllComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenGroupsRoutingModule {
}
